import { render, staticRenderFns } from "./ExpandableBox.vue?vue&type=template&id=64cba268"
import script from "./ExpandableBox.vue?vue&type=script&lang=js"
export * from "./ExpandableBox.vue?vue&type=script&lang=js"
import style0 from "./ExpandableBox.vue?vue&type=style&index=0&id=64cba268&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports